import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import DatePicker from "react-datepicker"
import { Dropdown } from 'react-bootstrap'
import { startOfMonth, endOfMonth, format } from 'date-fns'
import Select from 'react-select'
import XLSX from 'xlsx'

import useDidMountEffect from 'pages/parts/useDidMountEffect'
import SummaryLoyalty from 'pages/main/reports/SummaryLoyalty'
import SummaryExpense from 'pages/main/reports/SummaryExpense'
import SummaryExpenseIncome from 'pages/main/reports/SummaryExpenseIncome'
import SummaryIncomes from 'pages/main/reports/SummaryIncomes'
import SummaryDebt from 'pages/main/reports/SummaryDebt'
import SummaryCash from 'pages/main/reports/SummaryCash'
import SummaryBank from 'pages/main/reports/SummaryBank'
import SummarySalary from 'pages/main/reports/SummarySalary'
import SammarySafe from 'pages/main/reports/SammarySafe'
import SummarySales from 'pages/main/reports/SummarySales'
import SummaryAllowances from 'pages/main/reports/SummaryAllowances'
import SummaryGrossIncome from 'pages/main/reports/SummaryGrossIncome'

import { httpOk, GET } from 'helpers/api'
import { formatMoney, returnSign, formatDate } from 'helpers/helpers'
import CustomTooltip from "pages/parts/CustomTooltip"

function Summary() {
	const { t } = useTranslation()
	const date = new Date()

	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState([])
	const [menu, setMenu] = useState([])
	const [poses, setPoses] = useState([])
	const [overall, setOverall] = useState({})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterData, setFilterData] = useState({
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		pos_id: reduxAccount.pos_id,
		type: null,
		random: 0,
		random_active_modal: 0,
	})
	const [activeModal, setActiveModal] = useState(0)

	async function searchWithFilter() {
		var filterDataCopy = { ...filterData }
		var filterUrl = `/report-summary`
		var urlParams = ""

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.menu_ids && filterDataCopy.menu_ids.length > 0) {
			const ids = filterDataCopy.menu_ids.map(item => item.id).join(',');
			urlParams += returnSign(urlParams) + 'menu_ids=' + ids;
		}
		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setOverall(response.data)
			setData(response.data.data)
		}

		setDropdownIsOpen(false)
	}

	async function exportToExcel() {
		var excelHeaders = [[
			t('date'), t('good_reception'), t('paid_supplier'), t('sales'), t('gross_income'), t('discount'), t('bonus'),
			t('expense'), t('salary'), t('prepaid_expense'), t('salary_balance'),
			t('cash'), t('bank'), t('debt'), t('debt_returned'), t('net_profit')
		]]

		for (let i = 0; i < data.length; i++) {
			var excelItems = []
			excelItems.push(data[i].days)
			excelItems.push(Number(data[i]['documents_in_total_amount']))
			excelItems.push(Number(data[i]['supplier_total_amount']))
			excelItems.push(Number(data[i]['sales_total_amount']))
			excelItems.push(Number(data[i]['gross_income_total_amount']))
			excelItems.push(Number(data[i]['cheque_total_discount']))
			excelItems.push(Number(data[i]['cheque_total_agent_amount']))
			excelItems.push(Number(data[i]['expenses_total_amount']))
			excelItems.push(Number(data[i]['salary_debt']))
			excelItems.push(Number(data[i]['salary_total_paid']))
			excelItems.push(Number(data[i]['salary_balance']))
			excelItems.push(Number(data[i]['cash_total_amount']))
			excelItems.push(Number(data[i]['terminal_total_amount']))
			excelItems.push(Number(data[i]['client_debtor_amount_out']))
			excelItems.push(Number(data[i]['client_debtor_amount_in']))
			excelItems.push(Number(data[i]['net_profit']))
			excelHeaders.push(excelItems)
		}

		excelHeaders.push([
			t('total'),
			Number(overall['documents_in_overall']),
			Number(overall['supplier_overall']),
			Number(overall['sales_overall']),
			Number(overall['gross_incomes_overall']),
			Number(overall['cheque_discount_overall']),
			Number(overall['cheque_agent_amount_overall']),
			Number(overall['expenses_overall']),
			Number(overall['salary_debt_overall']),
			Number(overall['salary_overall']),
			Number(overall['salary_balance_overall']),
			Number(overall['cash_overall']),
			Number(overall['terminal_overall']),
			Number(overall['overall_debt']),
			Number(overall['client_debtor_in_overall']),
			Number(overall['net_profit_overall']),
		])

		const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
		XLSX.writeFile(wb, t('summary_report') + ".xlsx");
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function handleSelectedDate(type, month = true, date) {
		if (month) {
			setFilterData({
				...filterData,
				'start_date': format(startOfMonth(new Date(filterData.start_date)), 'yyyy-MM-dd'),
				'end_date': format(endOfMonth(new Date(filterData.start_date)), 'yyyy-MM-dd'),
				'type': type,
				'random_active_modal': filterData.random_active_modal + 1,
			})
		} else {
			setFilterData({
				...filterData,
				'start_date': date,
				'end_date': date,
				'type': type,
				'random_active_modal': filterData.random_active_modal + 1,
			})
		}
	}

	async function getPoses() {
		var response = await GET('/helper/poses')
		if (httpOk(response)) {
			setPoses(response.data)
			if (response.data.length > 0) {
				setFilterData({
					...filterData,
					'pos_id': response.data[0]['id'],
					'random': filterData.random + 1,
				})
			}
		}
	}

	async function getMenu() {
		const response = await GET('/helper/menu', {}, { loader: true })
		if (httpOk(response)) setMenu(response.data)
	}

	useEffect(() => {
		getPoses()
		getMenu()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useDidMountEffect(() => {
		searchWithFilter()
	}, [filterData.random]) // eslint-disable-line react-hooks/exhaustive-deps

	useDidMountEffect(() => {
		setActiveModal(filterData.type)
	}, [filterData.random_active_modal]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header">
				<h4 className="vertical-center h-100">
					{t('summary_report')}
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex gap-2">
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'pos_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('date')}</label>
												<div className="calendar-input">
													<DatePicker
														showMonthYearPicker
														showFullMonthYearPicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('menu')}</label>
												<Select
													isMulti
													isClearable
													options={menu}
													value={filterData.menu_ids}
													onChange={(options) => setFilterData({ ...filterData, 'menu_ids': options ? options : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter(false)}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<CustomTooltip text={t('EXCEL')}>
									<button className="btn btn-outline-primary btn-wide-2"
										onClick={() => exportToExcel()}>
										<i className="uil uil-file-download-alt"></i>
									</button>
								</CustomTooltip>
							</div>
						</div>
					</div>

					<div className="table-responsive table-fixed mb-3">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th>{t('date')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis" title={t('sales')}>{t('sales')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis" title={t('allowances')}>{t('allowances')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis" title={t('sales_amount')}>{t('sales_amount')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis" title={t('gross_income')}>{t('gross_income')}</th>
									<th style={{ 'minWidth': '30px' }} className="text-end td-ellipsis">%</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis" title={t('good_reception')}>{t('good_reception')}</th>
									<th style={{ 'minWidth': '30px' }} className="text-end td-ellipsis">%</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis" title={t('paid_supplier')}>{t('paid_supplier')}</th>
									<th style={{ 'minWidth': '30px' }} className="text-end td-ellipsis">%</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis" title={t('discount')}>{t('discount')}</th>
									<th style={{ 'minWidth': '30px' }} className="text-end td-ellipsis">%</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis" title={t('expense')}>{t('expense')}</th>
									<th style={{ 'minWidth': '30px' }} className="text-end td-ellipsis">%</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis" title={t('income')}>{t('income')}</th>
									<th style={{ 'minWidth': '30px' }} className="text-end td-ellipsis">%</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis" title={t('salary')}>{t('salary')}</th>
									<th style={{ 'minWidth': '30px' }} className="text-end td-ellipsis">%</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis" title={t('paid')}>{t('paid')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis" title={t('salary_balance')}>{t('salary_balance')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis">{t('cash')}	</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis">{t('bank')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis">{t('loyalty')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end td-ellipsis">{t('debt')}</th>
									<th style={{ 'minWidth': '30px' }} className="text-end td-ellipsis">%</th>
									<th className="text-end td-ellipsis">
										<CustomTooltip text={`${t('net_profit')} = ${t('gross_income')} - ${t('good_reception')} - ${t('discount')} - ${t('expense')} + ${t('income')} - ${t('salary')} - ${t('debt')}`}>
											{t('net_profit')}
										</CustomTooltip>
									</th>
									<th style={{ 'minWidth': '30px' }} className="text-end td-ellipsis">%</th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}>
										<td>{formatDate(item.days)}</td>
										<td className="text-end text-nowrap">
											{formatMoney(item.sales)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('allowances', false, item.days)}>
											{formatMoney(item.allowances)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('sales', false, item.days)}>
											{formatMoney(item.sales_total_amount)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('gross_income', false, item.days)}>
											{formatMoney(item.gross_income_total_amount)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('gross_income', false, item.days)}>
											{formatMoney(item.gross_income_percentage, 2)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('incomes', false, item.days)}>
											{formatMoney(item.documents_in_total_amount)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('gross_income', false, item.days)}>
											{formatMoney(item.documents_in_total_percentage, 2)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('incomes', false, item.days)}>
											{formatMoney(item.supplier_total_amount)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('incomes', false, item.days)}>
											{formatMoney(item.suppliers_percentage, 2)}
										</td>
										<td className="text-end text-nowrap">
											{formatMoney(item.total_discount)}
										</td>
										<td className="text-end text-nowrap">
											{formatMoney(item.total_percentage)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('expenses', false, item.days)}>
											{formatMoney(item.expenses_total_amount, 2)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('expenses', false, item.days)}>
											{formatMoney(item.expenses_percentage, 2)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('expenses_incomes', false, item.days)}>
											{formatMoney(item.incomes_total_amount)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('expenses_incomes', false, item.days)}>
											{formatMoney(item.incomes_percentage, 2)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('salary', false, item.days)}>
											{formatMoney(item.salary_debt)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('salary', false, item.days)}>
											{formatMoney(item.salary_debt_percentage, 2)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('salary', false, item.days)}>
											{formatMoney(item.salary_total_paid)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('salary', false, item.days)}>
											{formatMoney(item.salary_balance)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('cash', false, item.days)}>
											{formatMoney(item.cash_total_amount)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('bank', false, item.days)}>
											{formatMoney(item.bank_total_amount)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('loyalty', false, item.days)}>
											{formatMoney(item.loyalty_amount_out)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('debt', false, item.days)}>
											{formatMoney(item.debt_total_amount_out)}
										</td>
										<td className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('debt', false, item.days)}>
											{formatMoney(item.debtors_percentage)}
										</td>
										<td className="text-end text-nowrap">{formatMoney(item.net_profit)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.net_profit_percentage, 2)}</td>
									</tr>
								))}
							</tbody>
							<tfoot>
								{data.length > 0 &&
									<tr>
										<th><b>{t('total')}</b></th>
										<th className="text-end text-nowrap hover">
											<b>{formatMoney(overall.overall_sales)}</b>
										</th>
										<th className="text-end text-nowrap hover">
											<b>{formatMoney(overall.overall_allowances)}</b>
										</th>
										<th className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('sales')}>
											<b>{formatMoney(overall.sales_overall)}</b>
										</th>
										<th className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('gross_income')}>
											<b>{formatMoney(overall.gross_incomes_overall)}</b>
										</th>
										<th><b>{formatMoney(overall.overall_gross_income_percentage, 2)}</b></th>
										<th className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('incomes')}>
											<b>{formatMoney(overall.documents_in_overall)}</b>
										</th>
										<th className="text-end text-nowrap hover">
											<b>{formatMoney(overall.overall_documents_in_percentage, 2)}</b>
										</th>
										<th className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('incomes')}>
											<b>{formatMoney(overall.supplier_overall)}</b>
										</th>
										<th className="text-end text-nowrap hover">
											<b>{formatMoney(overall.overall_suppliers_percentage, 2)}</b>
										</th>
										<th className="text-end text-nowrap"><b>{formatMoney(overall.cheque_discount_overall)}</b></th>
										<th></th>
										<th className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('expenses', true)}>
											<b>{formatMoney(overall.expenses_overall)}</b>
										</th>
										<th><b>{formatMoney(overall.overall_expenses_percentage, 2)}</b></th>
										<th className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('expenses_incomes', true)}>
											<b>{formatMoney(overall.incomes_overall)}</b>
										</th>
										<th><b>{formatMoney(overall.overall_income_percentage, 2)}</b></th>
										<th className="text-end text-nowrap"><b>{formatMoney(overall.salary_debt_overall)}</b></th>
										<th className="text-end text-nowrap"><b>{formatMoney(overall.overall_salary_percentage, 2)}</b></th>
										<th className="text-end text-nowrap"><b>{formatMoney(overall.salary_overall)}</b></th>
										<th className="text-end text-nowrap"><b>{formatMoney(overall.salary_balance_overall)}</b></th>
										<th className="text-end text-nowrap"><b>{formatMoney(overall.cash_overall)}</b></th>
										<th className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('bank')}>
											<b>{formatMoney(overall.bank_overall)}</b>
										</th>
										<th className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('loyalty')}>
											<b>{formatMoney(overall.loyalty_overall)}</b>
										</th>
										<th className="text-end text-nowrap hover"
											onClick={() => handleSelectedDate('debt')}>
											<b>{formatMoney(overall.overall_debt)}</b>
										</th>
										<th className="text-end text-nowrap"><b>{formatMoney(overall.overall_debt_percentage, 2)}</b></th>
										<th className="text-end text-nowrap"><b>{formatMoney(overall.net_profit_overall)}</b></th>
										<th className="text-end text-nowrap"><b>{formatMoney(overall.overall_net_profit_percentage, 2)}</b></th>
									</tr>
								}
							</tfoot>
						</table>
					</div>

					<div className="w-100 d-flex justify-content-between">
						<div className="flex-column">
							<h5 className="d-flex justify-content-between gap-3">
								<strong>{t('cheques')}:</strong>
								<span>{formatMoney(overall.total_cheques)}</span>
							</h5>
							<h5 className="d-flex justify-content-between gap-3">
								<strong>{t('guests')}:</strong>
								<span>{formatMoney(overall.total_people_number)}</span>
							</h5>
						</div>
					</div>
				</div>
			</div>

			{activeModal === 'expenses' &&
				<SummaryExpense
					setActiveModal={setActiveModal}
					filterData={filterData}>
				</SummaryExpense>
			}
			{activeModal === 'expenses_incomes' &&
				<SummaryExpenseIncome
					setActiveModal={setActiveModal}
					filterData={filterData}>
				</SummaryExpenseIncome>
			}
			{activeModal === 'incomes' &&
				<SummaryIncomes
					setActiveModal={setActiveModal}
					filterData={filterData}>
				</SummaryIncomes>
			}
			{activeModal === 'cash' &&
				<SummaryCash
					setActiveModal={setActiveModal}
					filterData={filterData}>
				</SummaryCash>
			}
			{activeModal === 'bank' &&
				<SummaryBank
					setActiveModal={setActiveModal}
					filterData={filterData}>
				</SummaryBank>
			}
			{activeModal === 'debt' &&
				<SummaryDebt
					setActiveModal={setActiveModal}
					filterData={filterData}>
				</SummaryDebt>
			}
			{activeModal === 'salary' &&
				<SummarySalary
					setActiveModal={setActiveModal}
					filterData={filterData}>
				</SummarySalary>
			}
			{activeModal === 'loyalty' &&
				<SummaryLoyalty
					setActiveModal={setActiveModal}
					filterData={filterData}>
				</SummaryLoyalty>
			}
			{activeModal === 'safe' &&
				<SammarySafe
					setActiveModal={setActiveModal}
					filterData={filterData}>
				</SammarySafe>
			}
			{activeModal === 'sales' &&
				<SummarySales
					setActiveModal={setActiveModal}
					filterData={filterData}>
				</SummarySales>
			}
			{activeModal === 'allowances' &&
				<SummaryAllowances
					setActiveModal={setActiveModal}
					filterData={filterData}>
				</SummaryAllowances>
			}
			{activeModal === 'gross_income' &&
				<SummaryGrossIncome
					setActiveModal={setActiveModal}
					filterData={filterData}>
				</SummaryGrossIncome>
			}
		</>
	)
}

export default Summary